import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "error", "submit"]
  
  connect() {
    this.validateEmail()
  }
  
  validateEmail() {
    const email = this.inputTarget.value
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    
    if (email === "") {
      this.clearError()
      this.submitTarget.disabled = true
      return
    }
    
    if (!emailRegex.test(email)) {
      this.showError("Veuillez entrer une adresse email valide")
      this.submitTarget.disabled = true
    } else {
      this.clearError()
      this.submitTarget.disabled = false
    }
  }
  
  showError(message) {
    if (!this.hasErrorTarget) {
      const errorDiv = document.createElement("div")
      errorDiv.className = "text-sm text-red-600 mt-1"
      errorDiv.dataset.emailValidationTarget = "error"
      this.inputTarget.parentNode.appendChild(errorDiv)
    }
    
    this.errorTarget.textContent = message
    this.inputTarget.classList.add("border-red-500", "focus:border-red-500", "focus:ring-red-500")
    this.inputTarget.classList.remove("border-gray-300", "focus:border-blue-500", "focus:ring-blue-500")
  }
  
  clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ""
    }
    
    this.inputTarget.classList.remove("border-red-500", "focus:border-red-500", "focus:ring-red-500")
    this.inputTarget.classList.add("border-gray-300", "focus:border-blue-500", "focus:ring-blue-500")
  }
}